import { render, staticRenderFns } from "./gameserveradd.vue?vue&type=template&id=6d08aa2e&scoped=true"
import script from "./gameserveradd.vue?vue&type=script&lang=js"
export * from "./gameserveradd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d08aa2e",
  null
  
)

export default component.exports